"use strict";

require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Currency = $("#meta_currency").attr("content");
exports.Currency = Currency;
function formatCurrency(value) {
  var val = value.toLocaleString('de-DE', {
    style: "currency",
    currency: "" + Currency,
    useGrouping: true
  }).replace('.', ' ');
  if (Currency == 'PLN') {
    val = val.replace("PLN", "zł");
  }
  return val;
}
exports.formatCurrency = formatCurrency;